export default __webpack_public_path__ + "static/media/plus-circle.bdcd2700.svg";